import { IBaseAction } from '../../../../common/interfaces/IBaseAction'
export enum Keys {
    LOADRESERVATIONROOM = 'react/reservation/LOADRESERVATIONROOM',
    LOADRESERVATIONROOM_PENDING = 'react/reservation/LOADRESERVATIONROOM_PENDING',
    LOADRESERVATIONROOM_FULFILLED = 'react/reservation/LOADRESERVATIONROOM_FULFILLED',
    LOADRESERVATIONROOM_REJECTED = 'react/reservation/LOADRESERVATIONROOM_REJECTED',

    LOADROOMS = "react/reservation/LOADROOMS",
    LOADROOMS_FULFILLED = "react/reservation/LOADROOMS_FULFILLED",
    LOADROOMS_REJECTED = "react/reservation/LOADROOMS_REJECTED",

    LOADRESEVATIONSSLOT = "react/reservation/LOADRESEVATIONSSLOT",
    LOADRESEVATIONSSLOT_PENDING = "react/reservation/LOADRESEVATIONSSLOT_PENDING",
    LOADRESEVATIONSSLOT_FULFILLED = "react/reservation/LOADRESEVATIONSSLOT_FULFILLED",
    LOADRESEVATIONSSLOT_REJECTED = "react/reservation/LOADRESEVATIONSSLOT_REJECTED",

    ADDRESERVATION = "react/reservation/ADDRESERVATION",
    ADDRESERVATION_PENDING = "react/reservation/ADDRESERVATION_PENDING",
    ADDRESERVATION_FULFILLED = "react/reservation/ADDRESERVATION_FULFILLED",
    ADDRESERVATION_REJECTED = "react/reservation/ADDRESERVATION_REJECTED",

    DELETERESERVATION = "react/reservation/DELETERESERVATION",
    DELETERESERVATION_PENDING = "react/reservation/DELETERESERVATION_PENDING",
    DELETERESERVATION_FULFILLED = "react/reservation/DELETERESERVATION_FULFILLED",
    DELETERESERVATION_REJECTED = "react/reservation/DELETERESERVATION_REJECTED",
    
    
    SETROOMSELECTED = "react/reservation/SETROOMSELECTED",
    SETDAYSELECTED = "react/reservation/SETDAYSELECTED",
    UPDATEVIEWTYPE = "react/reservation/UPDATEVIEWTYPE",
    RESETRESPONSE = "react/reservation/RESETRESPONSE",

    OTHER_ACTION = 'react/reservation/__any_other_action__',
}

export type Types = IBaseAction<Keys>;